import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { DDVModel } from '../model/field.model';

export function duplicateValueValidator(
    duplicateValueSubject: BehaviorSubject<DDVModel>
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').toString().trim();
    if (!value) {
      return null;
    }

    let { excludedValue, existingValues } = duplicateValueSubject.value;

    const normalizedValue = value.toLowerCase()
     excludedValue = (excludedValue ?? '').toString().trim().toLowerCase();

    if (excludedValue && normalizedValue === excludedValue) {
      return null;
    }

    const isDuplicate = existingValues.find((item)=>item.toString().trim().toLowerCase() === normalizedValue)

    return isDuplicate ? { duplicateName: { message: 'The value is already exists.' } } : null;
  };
}
